import { render } from "./RegisterNavigation.vue?vue&type=template&id=47288fdc&scoped=true&lang=pug"
import script from "./RegisterNavigation.vue?vue&type=script&lang=js"
export * from "./RegisterNavigation.vue?vue&type=script&lang=js"

import "./RegisterNavigation.vue?vue&type=style&index=0&id=47288fdc&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47288fdc"]])

export default __exports__